exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".movestic-details {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-left: 3.5rem;\n  padding-right: 3.5rem;\n  padding-top: 12rem;\n}\n\n.movestic-details>div>.movestic-logo {\n  height: 10rem;\n  width: auto;\n}\n\n.movestic-details>div p {\n  margin-top: 7rem;\n  white-space: pre-wrap;\n}\n\n.movestic-details>div>ul {\n  text-align: left;\n}\n\n@media only screen and (min-width: 1024px) {\n  .movestic-details>div>.movestic-logo {\n    height: 12rem;\n    width: auto;\n  }\n\n  .movestic-details>div p {\n    font-size: 4rem;\n  }\n}\n\n", ""]);

// exports
